import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
// NOTE: StrictMode removed intentionally.
// In development, StrictMode double-mounts components which breaks
// the Html5Qrcode scanner (creates two video streams fighting for the same DOM).
root.render(
  <App />
);